import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators, FormArrayName } from '@angular/forms';
import { AddallowancepopupComponent } from '../../generalpopup/addallowancepopup/addallowancepopup.component';
import { AdddeductionpopupComponent } from '../../generalpopup/adddeductionpopup/adddeductionpopup.component';
@Component({
  selector: 'app-addpayadjdetail',
  templateUrl: './addpayadjdetail.component.html',
  styleUrls: ['./addpayadjdetail.component.css']
})
export class AddpayadjdetailComponent implements OnInit {


  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal
  , private confirmationDialogService: ConfirmationDialogService,
    private productFindService: NgbModal) { }

  //Save Validation
  submitted: boolean;
  successfully: boolean;

  isduplicate: boolean;

  isallowanceaddmode: boolean = false;

  payadjdetailform = new FormGroup({
    payadjdetid: new FormControl(0),
    allowanceid: new FormControl(null, Validators.required),
    amount: new FormControl(null, Validators.required),
    deductionid: new FormControl(null),
  });

  allowanceColl: any = [];
  deductionColl: any = [];

  @Input() payadjdetid: any = 0;
  @Input() allowanceid: any = null;
  @Input() amount: any = null;
  @Input() deductionid: any = 0;
  @Input() formname: String = null;
  @Input() payadjdetailColl: any = [];

  @Input() adjustmenttype: String = null;

  @Output() emitData = new EventEmitter();

  ngOnInit() {

    this.fnCheckUserPririvilage();
    this.isduplicate = false;
    
    this.payadjdetailform.reset();
    this.fnInitializeFormGroup();
    this.fngetAllowance();
    this.fngetDeduction();

  }

  fnCheckUserPririvilage() {
  
    this.isallowanceaddmode= this.loginService.fnCheckUserRoleAction("Allowance", 'CREATE')
   
  }


  fnInitializeFormGroup() {
    this.payadjdetailform.setValue({
      payadjdetid: this.payadjdetid,
      allowanceid: this.allowanceid,
      amount: this.amount,
      deductionid: this.deductionid,
    })

  }
  fngetAllowance() {
    var data = {
      'allowanceid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': ""
    }
    this.appService.getAllowance(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.allowanceColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetDeduction() {
    var data = {
      'deductionid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': ""
    }
    this.appService.getDeduction(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.deductionColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnResetValidator() {
    
  }

  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
      this.isduplicate = false;
      //Validate
      if (this.payadjdetailform.valid) {

        var _allowancename = "";
        var _deductionname = "";
        for (let row of this.allowanceColl) {
          if (row.allowanceid === this.payadjdetailform.get('allowanceid').value) {
            _allowancename = row.allowancename;
          }

        }

        for (let row of this.payadjdetailColl) {
          if (row.allowanceid === this.payadjdetailform.get('allowanceid').value && this.allowanceid !== this.payadjdetailform.get('allowanceid').value) {
            this.isduplicate = true;
            return;
          }
        }

        for (let row of this.deductionColl) {
          if (row.deductionid === this.payadjdetailform.get('deductionid').value) {
            _deductionname = row.deductionname;           
          }
        }
      

        //Check
        var data = {
          payadjdetid: this.payadjdetid,
          allowanceid: this.payadjdetailform.get('allowanceid').value,
          deductionid: this.payadjdetailform.get('deductionid').value,
          amount: this.payadjdetailform.get('amount').value,
          allowancename: _allowancename,
          deductionname: _deductionname,
        }



        this.emitData.emit(data);
        this.activeModal.close(true);


      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }

  }


  //AddAllowance
  private fnAddAllowance() {

    const modalRef = this.productFindService.open(AddallowancepopupComponent, { size: <any>'xl' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetAllowance();

      if (receivedEntry > 0) {
        this.payadjdetailform.patchValue({ allowanceid: receivedEntry })
      }
    });

  }

  fnSetFormValidator() {
    
  }

  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
